<template>
  <div class="wrapper" :class="[writable ? 'wrapper--writable' : '', splittable ? `wrapper--splittable` : '', split ? `wrapper--split wrapper--split-${split}` : '']" ref="wrapper">
    <resize-observer @notify="recenter" />

    <div class="content" ref="content" v-html="content" @click="clicked" @mouseover="hovered" @mouseout="hoveredout"></div>
  </div>
</template>

<script>
  function addClass(nodes, className) {
    Array.prototype.slice.call(nodes).forEach(el => {
      el.classList.add(className)
    })
  }

  function removeClass(nodes, className) {
    Array.prototype.slice.call(nodes).forEach(el => {
      el.classList.remove(className)
    })
  }

  import Vue from 'vue';

  export default {
    props: {
      content: {
        type: String
      },

      index: {
        type: Number,
        default: 0
      },

      writable: {
        type: Boolean,
        default: false
      },

      splittable: {
        type: Boolean,
        default: true
      },

      split: {
        type: String,
        default: null
      }
    },

    methods: {
      elementsAtIndex: function elementsAtIndex(index) {
        return this.$refs.content.querySelectorAll(`.foo-${index}`);
      },

      inViewport: function inViewport(elements) {
        return Array.prototype.slice.call(elements).every(element => {
          const rect = element.getBoundingClientRect();

          return (
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) - 30 // a bit of padding
          )
        })
      },

      scrollTo: function scrollTo(elements, instant = false) {
        if (!elements.length) {
          return;
        }

        const offsetTop = elements[0].offsetTop
        const offsetBottom = elements[elements.length - 1].offsetTop + elements[elements.length - 1].offsetHeight;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        let top = offsetTop + ((offsetBottom - offsetTop) / 2) - (viewportHeight / 2)

        if (this.split) {
          if (this.split === 'bottom') {
            top -= viewportHeight / 4
          }
        }

        this.doScroll(top, !instant)
      },

      doScroll(scrollTop, animate = true) {
        // easing functions http://goo.gl/5HLl8
        Math.easeInOutQuad = function (t, b, c, d) {
          t /= d/2;
          if (t < 1) {
            return c/2*t*t + b
          }
          t--;
          return -c/2 * (t*(t-2) - 1) + b;
        };

        Math.easeInCubic = function(t, b, c, d) {
          var tc = (t/=d)*t*t;
          return b+c*(tc);
        };

        Math.inOutQuintic = function(t, b, c, d) {
          var ts = (t/=d)*t,
          tc = ts*t;
          return b+c*(6*tc*ts + -15*ts*ts + 10*tc);
        };

        function scrollTo(elem, to, callback, duration) {
          function move(amount) {
            elem.scrollTop = amount;
          }
          function position() {
            return elem.scrollTop;
          }
          var start = position(),
            change = to - start,
            currentTime = 0,
            increment = 20;
          duration = (typeof(duration) === 'undefined') ? 500 : duration;
          var animateScroll = function() {
            // increment the time
            currentTime += increment;
            // find the value with the quadratic in-out easing function
            var val = Math.easeInOutQuad(currentTime, start, change, duration);
            // move the document.body
            move(val);
            // do the animation unless its over
            if (currentTime < duration) {
              requestAnimationFrame(animateScroll);
            } else {
              if (callback && typeof(callback) === 'function') {
                // the animation is done so lets callback
                callback();
              }
            }
          };
          animateScroll();
        }

        if (animate) {
          scrollTo(this.$refs.wrapper, scrollTop)
        } else {
          this.$refs.wrapper.scrollTop = scrollTop
        }
      },

      move(override = false) {
        const content = this.$refs.content

        removeClass(content.querySelectorAll('.foo--full'), 'foo--full')
        removeClass(content.querySelectorAll('.foo--half'), 'foo--half')

        addClass(content.querySelectorAll(`.foo-${this.index}`), 'foo--full')

        if (this.index > 0) {
          addClass(content.querySelectorAll(`.foo-${this.index}.foo-${this.index - 1}`), 'foo--half')
        }

        //

        removeClass(content.querySelectorAll('.foo--past'), 'foo--past')

        if (this.index > 0) {
          let sel = [];

          for (let i = 0; i < this.index + 1; i++) {
            sel.push(i)
          }

          addClass(content.querySelectorAll(sel.map(x => { return `.foo-${x}` }).join(', ')), 'foo--past')
        }

        //

        this.scroll(override);
      },

      scroll(override) {
        const inc = this.lastIndex > this.index ? -1 : 1
        const nextEls = this.elementsAtIndex(this.index + inc);
        const currentEls = this.elementsAtIndex(this.index);

        // TODO - current one too (i.e., last)
        if (nextEls.length && !this.inViewport(nextEls) || !this.inViewport(currentEls) || override) {
          this.scrollTo(this.elementsAtIndex(this.index), override)
        }
      },

      recenter() {
        // TODO
      },

      clicked(e) {
        if (this.writable) {
          const matches = e.target.classList.value.match(/foo-([0-9]+)/)

          if (matches) {
            const index = +matches[1];

            this.$emit('indexed', index);
          }
        }
      },

      hovered(e) {
        if (this.writable) {
          const matches = e.target.classList.value.match(/foo-([0-9]+)/)

          if (matches) {
            const index = +matches[1];

            const els = this.$refs.content.querySelectorAll(`.foo-${index}`);
            els.forEach(el => {
              addClass(el, 'foo--hovered')
            })
          }
        }
      },

      hoveredout() {
        if (this.writable) {
          const els = this.$refs.content.querySelectorAll('.foo--hovered');
          els.forEach(el => {
            removeClass(el, 'foo--hovered');
          })
        }
      }
    },

    mounted() {
      this.lastIndex = this.index

      Vue.nextTick(function() {
        this.move(true);
      }, this)
    },

    watch: {
      content() {
        Vue.nextTick(function() {
          this.move(true);
        }, this);
      },

      index(index, lastIndex) {
        this.lastIndex = lastIndex
        this.move();
      },

      split() {
        Vue.nextTick(function() {
          this.move(true);
        }, this);
      }
    }
  }
</script>

<style scoped>
  .wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;

    display: grid;
    grid-template-rows: 1fr;
    align-items: center;

    padding: 0 calc(3rem + 5vw);
  
    overflow-y: hidden;
  }

  .wrapper--writable {
    overflow-y: auto;
    padding: 1rem !important;
  }

  .content {
    padding: 25vh 0;
    margin: 0 auto;
  }

  .wrapper--splittable.wrapper--split-bottom .content {
    margin-top: 50vh;
  }

  /deep/ .foo {
    opacity: 0.2;
    transition: opacity .25s ease-in-out;
  }

  /deep/ .foo--half {
    opacity: 0.65 !important;
  }

  /deep/ .foo--past {
    opacity: 0.5 !important;
  }

  /deep/ .foo--full {
    opacity: 1.0 !important;
  }

  /deep/ .foo--hovered {
    text-decoration: underline;
    cursor: pointer;
  }

  .wrapper--writable /deep/ .foo {
    opacity: 0.5 !important;
  }

  .wrapper--writable /deep/ .foo--full {
    opacity: 1.0 !important;
  }
</style>